




import { Component, Vue } from "vue-property-decorator";
import { LayoutModule } from "@/store/layout";
import AdUnitForm from "./Components/AdUnitForm.vue";
import AdUnit from "@/models/adUnit";
import AdUnitsAPI from "@/services/adUnits";

@Component({
  components: { AdUnitForm },
})
export default class NewAdUnit extends Vue {
  async save(model: AdUnit): Promise<void> {
    LayoutModule.showLoader();
    try {
      await AdUnitsAPI.new(model);
      LayoutModule.setAlerts({
        text: this.$t("ad_units.responses.success_create").toString(),
        type: "success",
      });
    } catch (e) {
      console.log(e);
    }
    LayoutModule.hideLoader();
  }

  cancel(): void {
    this.$router.push({ name: "ad_units" });
  }
}
